/**
 * 将数字格式化为千分位格式
 * @param num 要格式化的数字
 * @param decimal 保留的小数位数（默认 2 位）
 * @returns 格式化后的字符串
 */
export const formatNumberWithCommas = ({
  num,
  decimal = 2,
  type = 'en-US',
}: {
  num: number,
  decimal?: number
  type?: 'en-US' | 'zh-CN'
}): string => {
  return new Intl.NumberFormat(type, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  }).format(num)
};